// 토모플레이 - 지사 - 원별 사용량 - 상세 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import ReactEcharts from "echarts-for-react";
import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";
import CommonVerticalBarChart from "../../components/CommonVerticalBarChart";

import jelliingStyle from "../../components/style";

const ContentNursery = forwardRef(({ statPeriod, viewCategory, branchName, nurseryId, nurseryName, updateViewSubOption, onClassSelected }, ref) => {
    const [stat, setStat] = useState(false);
    const [statConnect, setStatConnect] = useState(false);
    const [statPlay, setStatPlay] = useState(jelliingStyle.seriesHomeDivision);
    const [pickPlaySumCount, setTotalPickPlayCount] = useState([{id:"pickPlaySum", field:"pickPlaySum", value: 0, name: "젤링's pick"}]);
    const [statClassCount, setClassCount] = useState(false);
    const [barChartSize, setBarChartSize] = useState(0);
    const [statJoinCount, setJoinCount] = useState(false);
    const [joinCountSum, setJoinCountSum] = useState(false);
    const [childStatDate, setChildStatDate] = useState(false);


    const defaultChartSize = 45;

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            var connect = [];
            var contentSum = [];
            statConnect.map((s) => connect.push(s.value));
            statPlay.map((s) => contentSum.push(s.value));
            const excelData = {
                fileName: `젤링_홈스쿨링_${nurseryName}`,
                sheets: [
                    {
                        name: "접속 수",
                        title: `접속 수`,
                        data: statConnect
                        ? statConnect.map((s) => ([s.name, s.value]))
                        : [],
                        
                    },
                    {
                        name: "콘텐츠 사용량",
                        title: `콘텐츠 사용량`,
                        columnTitle: [].concat(statPlay.map((s) => s.name)),
                        data: [[statPlay[0].value, statPlay[1].value]]
                    },
                    {
                        name: "반별 콘텐츠 사용량",
                        title: `반별 콘텐츠 사용량`,
                        columnTitle: ["반명"].concat(statPlay ? statPlay.map((s) => s.name) : []),
                        data: statClassCount
                            ? statClassCount.map((s) => ([s.className].concat(statPlay.map((lc) => s[lc.field]))))
                            : [],
                    },
                    {
                        name: "학부모 가입 현황",
                        title: `학부모 가입 현황`,
                        columnTitle: ["반 명", "계약 원아 수", "회원 가입 수"],
                        data: statJoinCount
                        ? statJoinCount.map((s) => ([s.name, s.quantity, s.childJoin]))
                        : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        axios({
            method: "POST",
            url: `/api/jelliing_stat/home/${nurseryId}/nursery/content`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    let today = new Date();
                    today.setDate(today.getDate() - 1);
                    var date = today.toISOString().slice(0, 10);

                    const stat = result.data.data;

                    let statConnect = [
                        { id: 0, name: "레벨 A", value: 0 },
                        { id: 1, name: "레벨 B", value: 0 },
                        { id: 2, name: "레벨 C", value: 0 },
                        { id: 3, name: "레벨 D", value: 0 },
                    ];

                    let statContentPlay = jelliingStyle.seriesHomeDivision;

                    let joinSum =  { quantity: 0, childJoin: 0 };

                    stat.classStat.map((c) => {
                        if(c.level == 0) statConnect[0].value += (c.homeConnectAnd + c.homeConnectIos) ; 
                        else if(c.level == 1) statConnect[1].value += (c.homeConnectAnd + c.homeConnectIos); 
                        else if(c.level == 2) statConnect[2].value += (c.homeConnectAnd + c.homeConnectIos); 
                        else if(c.level == 3) statConnect[3].value += (c.homeConnectAnd + c.homeConnectIos); 

                        statContentPlay.forEach(p => {
                            p.value = stat.homeContent.reduce((sum, item) => sum + (item[p.id] || 0), 0);
                        });

                    })


                    
                    const mergedStatList = stat.classInfo.map(n => {
                        const home = stat.homeContent.find(p => p.classId === n.id) ?? {};
                        return {
                            ...n,
                            ...(home),
                            className: home.className || n.name,  
                            classPlaySum: home.classPlaySum ?? 0,
                            libPlaySum: home.libPlaySum ?? 0
                        };
                    });
                    
                    const cleanStatClassCount = mergedStatList.map(item => {
                        const { undefined: _ignore, ...rest } = item;
                        return rest;
                    });

                    stat.classInfo.map((i) => {
                        joinSum.quantity += i.quantity ? i.quantity : 0;
                        joinSum.childJoin += i.childJoin ? i.childJoin : 0;

                    })

                    let joinCount = stat.classInfo;
                    
                    setChildStatDate(date)
                    setStat(stat);
                    setBarChartSize(defaultChartSize * mergedStatList.length);
                    setClassCount(cleanStatClassCount);  
                    setStatPlay(statContentPlay);
                    setStatConnect(statConnect);
                    setJoinCount(joinCount);
                    setJoinCountSum(joinSum);
                    
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }, [statPeriod, viewCategory]);
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    const optionContentPlay = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statPlay ? statPlay.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statPlay
                    ? statPlay
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${jelliingStyle.seriesJelliingColor.normal[idx]};"></span>`}${
                                      s.name
                                  }: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
            },
        },
        series: [
            {
                type: "pie",
                data: statPlay,
                radius: ["0%", "85%"],
                center: ["40%", "45%"],
                animation: true,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "right",
                },
                color: jelliingStyle.seriesJelliingColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "top",
        },
    };

    const chartOptionContent = {
        yAxis: { field: "className" },
        xAxis: {
            name: "건",
            series: jelliingStyle.seriesHomeDivision,
        },

        stacks: [{ stack: "base", showSum: true, showSumTooltip: true, showPercent: false }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "20%",
        },
    };

    const onChartClassSelect = (e) => {
        if (onClassSelected) {
            onClassSelected(e);
        }
    };

    const jelliingDateChartOption = {
        xAxis: { field: "name" },
        yAxis: {
            name: "건",
            series: [{id:"value", field:"value", name: "접속수", option: { itemStyle: { color: "#FE9A2E" } }}],
        },
        stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        showSum: true,
        sort: false,
        grid: {
            top: "15%",
            left: "5%",
            right: "5%",
        },
    };

    const childChartOption = {
        xAxis: {
            type: "category",
            data: ["가입 현황"],
        },
        yAxis: {
            name: "명",
            type: "value",
        },
        grid: {
            top: "20%",
            left: "10%",
            bottom: "10%",
        },
        legend: {
            x: "right",
        },
        tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
                type: "cross",
                crossStyle: {
                    color: "#999",
                },
            },
        },
        series: [
            {
                type: "bar",
                data: [joinCountSum ? joinCountSum.quantity : 0],
                ...jelliingStyle.seriesHomeChildChart[0],
            },
            {
                type: "bar",
                data: [joinCountSum ? joinCountSum.childJoin : 0],
                ...jelliingStyle.seriesHomeChildChart[1],
            },
        ],
    };

    const NurseryClassChild = ({ childStatDate, statList, height = 200 }) => {
        if (!statList) {
          return (
            <div className="w-100">
              <div className="row">
                <div
                  className="col"
                  style={{
                    height: "220px",
                    textAlign: "center",
                    paddingTop: `50px`,
                  }}
                >
                  <span className="dashboard-spinner spinner-xl"></span>
                </div>
              </div>
            </div>
          );
        } else {
          var totalClass = statList.length;    
          var totalQuantity = statList.reduce(
            (ac, current) => ac + (current.quantity ? current.quantity : 0),
            0
          );
          var totalChildJoin = statList.reduce(
            (ac, current) => ac + (current.childJoin ? current.childJoin : 0),
            0
          );
          
          const rateJoin = totalQuantity ? ((totalChildJoin / totalQuantity) * 100).toFixed() : 0;
          const heightValue = totalClass > 6 ? height + 'px' : '100%';
          
          return (
            <div className="w-100">
              <div className="text-right text-muted text-xs">
                * 원아 자료 기준일 - {childStatDate}
              </div>
              <table className="table table-sm table-striped text-center">
                <thead style={{display: "table", tableLayout: "fixed", width: "100%"}}>
                  <tr className="" style={{backgroundColor: '#b9c7dc'}}>
                    <th scope="col">반</th>
                    <th scope="col">계약 원아 수</th>
                    <th scope="col">회원 가입 수</th>
                  </tr>
                </thead>
                <tbody style={{ overflowY: "auto", display: "block", height: heightValue }}>
                  {statList.map((s, idx) => (
                    <tr key={`class-child-${idx}`} id={`class-child-${s.id}`} style={{display: "table", tableLayout: "fixed", width: "100%"}}>
                      <td className="" style={{backgroundColor: '#c8e6ef'}}>{s.name}</td>
                      <td>{(s.quantity ? s.quantity : 0).toLocaleString()}</td>
                      <td>{(s.childJoin ? s.childJoin : 0).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="" style={{color: "#ffffff", display: "table", tableLayout: "fixed", width: "100%", backgroundColor: '#7EC9EB'}}>
                    <td>합계</td>
                    <td>{totalQuantity.toLocaleString()}</td>
                    <td>{totalChildJoin.toLocaleString()}</td>
                  </tr>
                  <tr className="" style={{display: "table", tableLayout: "fixed", width: "100%", backgroundColor: '#86dd8d'}}>
                    <td>가입 비율</td>
                    <td className="text-bold" colSpan={2}>
                      {rateJoin.toLocaleString()}%
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          );
        }
      };

    return (
        <div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">접속 수 </h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statConnect} chartOption={jelliingDateChartOption} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용량</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ReactEcharts theme="macarons" option={optionContentPlay} style={{ height: `280px` }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">반별 콘텐츠 사용량</h5>
                        </div>
                        <div className="card-body" style={{ height: `${barChartSize}px`, minHeight: '130px' }}>
                            <CommonVerticalBarChart chartData={statClassCount} chartOption={chartOptionContent} onSelect={onChartClassSelect} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                     <div className="card">
                        <div className={`card-header stat-content-card-title`}>가입 현황</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                                    <div className="">
                                        <NurseryClassChild height={220} statList={statJoinCount} childStatDate={childStatDate} />
                                    </div>
                                </div>
                                <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                                    <div className="">
                                        <ReactEcharts theme="macarons" style={{ height: "370px" }} option={childChartOption} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ContentNursery;
